export const reportDetailType ={
    FETCH_REPORTDETAILD_REQUEST:"FETCH_REPORTDETAILD_REQUEST",
    FETCH_REPORTDETAIL_SUCCESS:"FETCH_REPORTDETAIL_SUCCESS",
    FETCH_REPORTDETAIL_FAILURE:"FETCH_REPORTDETAIL_FAILURE",
    CLEAN_REPORTDETAIL:"CLEAN_REPORTDETAIL"
} 
